// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"5a95362a","633":"02bb07e2","652":"1cc46391"}[chunkId] + ".chunk.css";
};